export default __webpack_public_path__ + "static/media/reject-icon.10cc2c0d.svg";